import TableRow from '@mui/material/TableRow';
import AppTableCell from 'src/components/appComponents/table/AppTableCell';
import Label from 'src/components/label';
import { IPublishJobsDto } from 'src/types/publishJobs';

type Props = {
  row: IPublishJobsDto;
};

export default function PublishJobsTableRow({ row }: Props) {
  return (
    <>
      <TableRow hover>
        <AppTableCell value={row?.jobId} />
        <AppTableCell
          value={
            <Label
              color={
                row?.status === 'succeeded'
                  ? 'success'
                  : row?.status === 'running'
                    ? 'warning'
                    : 'error'
              }
            >
              {row?.status}
            </Label>
          }
        />
        <AppTableCell value={new Date(row?.createdAt)?.toLocaleDateString()} />
      </TableRow>
    </>
  );
}
